import { render, staticRenderFns } from "./SubmissionManagement.vue?vue&type=template&id=eb8c3a64&scoped=true&"
import script from "./SubmissionManagement.vue?vue&type=script&lang=js&"
export * from "./SubmissionManagement.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionManagement.vue?vue&type=style&index=0&id=eb8c3a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb8c3a64",
  null
  
)

export default component.exports